module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/vg-76c17dc332a16129789a6a33f58627a3.svg";